import { ChangeEvent } from 'react';
import { createUseStyles } from 'react-jss';
import { Theme } from '@app/theme';
import moment from 'moment';
import { useIsAdmin } from '@app/api';
import { Input } from '@app/form';

import { useOptionalField } from '../FormikFields';

const useStyles = createUseStyles((theme: Theme) => ({
  adminInputs: {
    display: 'flex',
    alignItems: 'center',
    gap: theme.marginBase * 2,
    padding: theme.marginBase * 2,
    border: `1px solid ${theme.colors.purpleAccessible}`,
    marginTop: theme.marginBase * 3,
  },
}));

interface Props {
  name: string;
}

export const AdminDateSelection = ({ name }: Props) => {
  const classes = useStyles();

  const isAdmin = useIsAdmin();
  const {
    field: { value },
    helpers,
  } = useOptionalField({ name });
  const momentValue = moment(value);

  if (!isAdmin || !helpers) {
    return null;
  }

  return (
    <div className={classes.adminInputs}>
      <Input
        type="date"
        value={momentValue.format('YYYY-MM-DD')}
        onChange={(e: ChangeEvent<HTMLInputElement>) => {
          const date = moment(e.currentTarget.value);
          if (date.isValid()) {
            date
              .hour(momentValue.hour())
              .minute(momentValue.minute())
              .second(momentValue.second());

            helpers.setValue(date.toISOString());
          }
        }}
        label="Date"
        noMargin
      />
      <Input
        type="time"
        value={momentValue.format('HH:mm:ss')}
        onChange={(e: ChangeEvent<HTMLInputElement>) => {
          const date = moment(e.currentTarget.value, 'HH:mm:ss');
          if (date.isValid()) {
            date
              .day(momentValue.day())
              .month(momentValue.month())
              .year(momentValue.year());

            helpers.setValue(date.toISOString());
          }
        }}
        label="Heure"
        noMargin
      />
    </div>
  );
};
